<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        {{ inputData.name }}
        <span class="glyphicon glyphicon-move pull-right"></span>
      </div>
      <div class="panel-body">
        <strong>{{ inputData.label }}</strong>
        <div v-if="inputData.type == 'text'"><input type="text" name="" value="" :placeholder="inputData.placeholder" class="form-control admin-form-control"></div>
        <div v-else-if="inputData.type == 'textarea'"><textarea name="" value="" :placeholder="inputData.placeholder" class="form-control admin-form-control"></textarea></div>
        <div v-else-if="inputData.type == 'radio'">
          <div v-for="(item, index) in inputData.options" :key="index">
            <input type='radio' :name="inputData.name" :value="index"> {{ item }}
          </div>
        </div>
        <div v-else-if="inputData.type == 'checkbox'">
          <div v-for="(item, index) in inputData.options" :key="index"><input type='checkbox' :name="inputData.name" :value="index"> {{ item }}</div></div>
        <div v-else-if="inputData.type == 'select'">
          <select name="" class="form-control admin-form-control">
            <option value=''>--select--</option>
            <option v-for="(v,k) in inputData.options" :key="k">{{ v }}</option>
          </select>
        </div>
        <br>
        <!-- <p v-if="inputData.required" class="small">* This field is required</p> -->
      </div>
      <div class="panel-footer">
        <a
          href=""
          type="button"
          class="btn admin-btn-primary text-uppercase"
          @click.prevent="showModal = true">
          <span class="glyphicon glyphicon-list"></span>
          Manage Option
        </a>
        <a
          href=""
          type="button"
          class="btn admin-btn-primary text-uppercase"
          @click.prevent="deleteItem(index)">
          <span class="glyphicon glyphicon-trash"></span>
          Remove
        </a><br>
      </div>
    </div>
    <transition name="modal" v-if="showModal">
      <div class="modal-mask" @click.prevent="showModal = false">
        <div class="modal-wrapper">
          <div class="modal-container" @click.prevent.stop>
            <div class="modal-header">
              Manage Options
            </div>
            <div class="modal-body form-horizontal">
              <!-- FIELD NAME -->
              <div class="form-group">
                <label for="fieldName" class="control-label col-sm-3">Field Name</label>
                <div class="col-sm-9">
                  <input id="fieldName" class="form-control admin-form-control" type="text" name="name" v-model="inputData.label" placeholder="Unique Field Identifier">
                </div>
              </div>

              <!-- PLACEHOLDER -->
              <div v-if="inputData.type == 'text' || inputData.type == 'textarea'" class="form-group">
                <label for="placeholder" class="col-sm-3">Placeholder</label>
                <div class="col-sm-9">
                  <input id="placeholder" class="form-control admin-form-control" type="text" name="placeholder" v-model="inputData.placeholder">
                </div>
              </div>

              <div>
                <button
                  :class="required ? 'admin-btn-primary btn' : 'btn-default btn'"
                  @click="inputData.required = !inputData.required">{{ required ? 'Required' : 'Not Required'}}</button>
                <!-- <label for="fieldName" class="control-label"> -->
                  <!-- <input type="checkbox" name="required_field" id="" :checked="inputData.required" @click="requiredClicked"> -->
                  <!-- <input type="checkbox" name="required_field" id="" v-model="inputData.required" @click="requiredClicked"> -->
                  <!-- Required -->
                <!-- </label> -->
                &nbsp;
                <button
                  :class="editable ? 'admin-btn-primary btn' : 'btn-default btn'"
                  @click="inputData.editable = !inputData.editable">{{ editable ? 'Editable' : 'Not Editable'}}</button>
                <!-- <label for="fieldName" class="control-label"> -->
                  <!-- <input type="checkbox" name="required_field" id="" v-model="inputData.editable"> -->
                  <!-- Editable -->
                <!-- </label> -->
              </div>
              <br>

              <!-- OPTIONS -->
              <div class="form-group" v-if="inputData.type == 'select' || inputData.type == 'radio' || inputData.type == 'checkbox'">
                <label for="addOption" class="col-sm-3">Option</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <input id="addOption" class="form-control admin-form-control" v-model="newOption" type="text" placeholder="Add Option">
                    <span @click="addOption" class="clickable glyphicon glyphicon-plus input-group-addon"></span>
                  </div>
                </div>
                <br>
              </div>

              <ul>
                <li v-for="(opt, idx) in inputData.options" :key="idx">
                  <span class="col-sm-11">
                    {{ opt }}
                  </span>
                  <a
                    @click.prevent='removeOption(idx)'
                    class="clickable">
                    <span class="glyphicon glyphicon-trash"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="modal-footer">
              <button class="close" @click="showModal = false">Close</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style>
.clickable:hover {
  cursor: pointer;
}

.modal-mask {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #0033ab;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}
</style>

<script>
/*
  inputData:
    name: label
    type: type of input
    options: for select, radio, and checkbox
*/
export default {
  name: 'FormItem',
  props: {
    inputData: Object,
    index: Number
  },
  data () {
    return {
      showModal: false,
      newOption: '',
      test: false
    }
  },
  computed: {
    required () {
      return this.inputData.required
    },
    editable () {
      return this.inputData.editable
    }
  },
  methods: {
    removeOption (index) {
      this.inputData.options.splice(index, 1)
    },
    addOption () {
      this.inputData.options.push(this.newOption)
      this.newOption = ''
    },
    deleteItem (index) {
      this.$bus.emit('remove-from-form', index)
    }
  }
}
</script>

<style scoped>
.panel-footer a.btn {
  margin-right: 5px;
}
</style>
